import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggleMobileNav(evt: Event) {
    evt.preventDefault();
    this.element.classList.toggle("show-menu");
  }
}
